import { useFlagsWithOverrides } from './useFlagsWithOverrides';

export const useFlagEnabledWithOverrides = (flagName: string): boolean => {
  const flags = useFlagsWithOverrides([flagName]);
  return flags[flagName].enabled;
};
